import { HttpClient } from '@angular/common/http';
import { EventEmitter, inject, Injectable } from '@angular/core';
import { AccountingIntegrationType } from 'enums/AccountingIntegrationType';
import { environment } from 'environments/environment';
import { BrandModel } from 'models/generated/Entities.GormCrm.Brand';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class BrandService {

	public ready = false;
	public onError = new EventEmitter<unknown>();

	private _brands?: BrandModel[];
	private _accountingSystemIntegrationPromise?: Promise<Record<string, AccountingIntegrationType>>;
	private readonly http = inject(HttpClient);

	async resolve(): Promise<void> {
		try {
			this._brands = await firstValueFrom(this.http.get<BrandModel[]>(`${environment.gatewayUrl}/api/brands`));

			const styleSheet = new CSSStyleSheet();
			for (const brand of this._brands) {
				// Insert logo URL as CSS variable for each available brand
				styleSheet.insertRule(`[brand='${brand.shortName}'] { --logo-url: url('data:image/svg+xml;base64,${brand.logo}'); }`);
			}
			document.adoptedStyleSheets.push(styleSheet);
			this.ready = true;
		}
		catch (error) {
			this.onError.next(error);
		}
	}

	get brands(): BrandModel[] {
		if (!this._brands) throw new Error('Brand list not yet loaded from backend');
		return this._brands;
	}

	getBrand(id?: string): BrandModel | undefined {
		return this.brands.find(brand => brand.id === id);
	}

	async getAccountingSystemIntegrationType(id?: string): Promise<AccountingIntegrationType | undefined> {

		if (!id) return undefined;
		if (!this._accountingSystemIntegrationPromise)
			this._accountingSystemIntegrationPromise = firstValueFrom(this.http.get<Record<string, AccountingIntegrationType>>(`${environment.gatewayUrl}/api/invoicing/brands-accounting-integration`));

		return (await this._accountingSystemIntegrationPromise)[id];
	}
}
